import { UserRound } from 'lucide-react';
import { Spinner } from '../components/Spinner';

/**
 * Marcador sobrio en lugar del avatar (D-9): silueta y "Paciente". Se ve
 * mientras el `.glb` carga, si no hay asset para el escenario, si el asset
 * falla o si el alumno apagó el avatar. La entrevista sigue igual.
 */
export function MarcadorPaciente({ cargando = false }: { cargando?: boolean }) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-slate-800 text-slate-300">
      <UserRound size={56} />
      <span className="text-sm">Paciente</span>
      {cargando && (
        // Abajo y no al centro: en la fase `preparada` la tarjeta de
        // "Iniciar entrevista" tapa el centro del recuadro.
        <span className="absolute bottom-3 left-3 flex items-center gap-2 text-xs text-slate-400">
          <Spinner size={12} /> Cargando paciente…
        </span>
      )}
    </div>
  );
}
